// Updated by Nic 2026-06-18
import React, { useState } from "react";
import "@styles/pages/EventForm/summary/EventSummaryPage.scss";
import { Trans } from "react-i18next";
import {
  Box,
  Typography,
} from "@mui/material";
import EventSection from "@sections/EventSection";
import { useLocation } from "react-router-dom";

const EventSummaryPage = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");

  const title = type === "galaxy_ai_academy" ? 'form:galaxy_ai_academy' : 'form:event_registration'

  return (
   <Box className="summary-page-container">
        <Typography className="title">
            <Trans i18nKey={title} />
        </Typography>
        <EventSection title={title}/>
    </Box>
  );
};

export default EventSummaryPage;
